import './CoralUVPFlipCard.scss'

import { Asset } from '@websrc/App/Components/Asset/Asset'
import { CTA } from '@websrc/App/Components/CTA'
import { mapCoralWebUVPFlipCard } from '@websrc/DataMappers/mapSpot'
import React, { useState } from 'react'

import { CheckIcon } from '../../../icons/Check.icon'
import { FlipCard } from '../FlipCard'

type CoralUVPFlipCardProps = ReturnType<typeof mapCoralWebUVPFlipCard>

export const CoralUVPFlipCard = (props: CoralUVPFlipCardProps) => {
  const [isHovered, setIsHovered] = useState(false)
  const [isFrontSide, setIsFrontSide] = useState(false)

  const handleHoverChange = (hovered: boolean) => {
    setIsHovered(hovered)
  }

  const content = {
    frontHeader: (
      <div>
        <div className={'coral-uvp-flip-card__front-headline'}>{props.header}</div>
      </div>
    ),
    frontContent: (
      <div
        className={`coral-uvp-flip-card__front-image-container` + (isHovered ? ' is-hovered' : '')}
      >
        <div className={`coral-uvp-flip-card__front-image`}>
          <Asset
            altText={'Placeholder Image'}
            objectFit={'cover'}
            srcSetWidths={[400, 600, 800, 1200, 1600]}
            thumbnail={props.asset}
          />
        </div>
      </div>
    ),
    backHeader: (
      <div>
        <div className={'coral-uvp-flip-card__back-headline'}>{props.header}</div>
      </div>
    ),
    backContent: (
      <>
        <div className={'coral-uvp-flip-card__back-paragraph'}>
          {props.paragraphs.map((text, id) => (
            <div className={'coral-uvp-flip-card__back-paragraph-section'} key={id}>
              <div>
                <CheckIcon />
              </div>
              <div>{text}</div>
            </div>
          ))}
        </div>
        {props.button?.text && (
          <div className={'coral-uvp-flip-card__cta-container'}>
            <CTA
              className={'coral-global-button m--type-fill m--theme-white'}
              cta={props.button}
              iconName={'upRightArrow'}
              isFocuseable={isFrontSide}
              type={'clean'}
            />
          </div>
        )}
      </>
    ),
  }

  return (
    <FlipCard
      animateFixedMobile={400}
      animateFixedTablet={612}
      animateHeight={true}
      backgroundColor={props.visuals}
      buttonColor={props.visuals}
      cardClassName={'coral-uvp-flip-card__animated-height-card'}
      className={'coral-uvp-flip-card'}
      content={content}
      headerBottomPadding={true}
      onFlipChange={setIsFrontSide}
      onHoverChange={handleHoverChange}
      unhoverOnClick={true}
    />
  )
}
